import Backbone from 'backbone';

export default Backbone.Model.extend({
  defaults: {
    customerCompanyValue: '',
    fieldSelected: 'company',
    inputValue: '',
    hiddenInputValue: ''
  },

  initialize: function() {
    this.on('change:fieldSelected', this.changeHiddenInputValue);
  },

  changeHiddenInputValue: function(model, value) {
    var hiddenInputValue = false;

    switch (value) {
      case 'company':
        hiddenInputValue = model.get('customerCompanyValue');
        break;

      case 'input':
        hiddenInputValue = model.get('inputValue');
        break;
    }

    if (hiddenInputValue !== false) {
      model.set('hiddenInputValue', hiddenInputValue);
    }
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/b2b/inputsetB2bCompanyModel.js
 **/